export const defaultLetterSpacingScale = {
    prefix: 'twist-core-letter-spacing',
    steps: {
        // TODO awaiting design
        base: { size: 1 }
    }
};
export const defaultLetterSpacingTokens = {
// TODO awaiting design
// 'twist-core-letter-spacing-base': '.01em',
// 'twist-core-letter-spacing-2': 'calc(2 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-4': 'calc(4 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-6': 'calc(6 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-8': 'calc(8 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-10': 'calc(10 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-25': 'calc(25 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-50': 'calc(50 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-75': 'calc(75 * var(--twist-core-letter-spacing-base))',
// 'twist-core-letter-spacing-100': 'calc(100 * var(--twist-core-letter-spacing-base))'
};
